import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  { transform: 'translate(6 5)' },
  React.createElement('path', { d: 'M16.94,15a4,4,0,1,1,4-4A4,4,0,0,1,16.94,15Zm0-7a3,3,0,1,0,3,3A3,3,0,0,0,16.94,8Z' }),
  React.createElement('circle', { cx: '16.94', cy: '11.02', r: '1.53' }),
  React.createElement('path', { d: 'M5.06,8.67a4,4,0,1,1,4-4A4,4,0,0,1,5.06,8.67Zm0-7a3,3,0,1,0,3,3A3,3,0,0,0,5.06,1.67Z' }),
  React.createElement('circle', { cx: '5.06', cy: '4.67', r: '1.53' }),
  React.createElement('path', { d: 'M5.06,21.33a4,4,0,1,1,4-4A4,4,0,0,1,5.06,21.33Zm0-7a3,3,0,1,0,3,3A3,3,0,0,0,5.06,14.33Z' }),
  React.createElement('circle', { cx: '5.06', cy: '17.33', r: '1.53' }),
  React.createElement('rect', {
    x: '7.77',
    y: '13.67',
    width: '6.45',
    height: '1',
    transform: 'translate(-5.38 6.85) rotate(-28.12)'
  }),
  React.createElement('rect', {
    x: '10.51',
    y: '4.58',
    width: '1',
    height: '6.47',
    transform: 'translate(-1.07 13.85) rotate(-61.88)'
  })
));